var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '../../base/styled/variables.styled';
const StyledCheckIcon = styled.svg `
  width: ${(props) => props.width || '24px'};
  height: ${(props) => props.height || '24px'};
  flex-shrink: 0;

  path {
    fill: ${(props) => props.color || colors.neutral800};
  }
	color: ${(props) => props.color || colors.neutral800};
`;
export const CheckIcon = (_a) => {
    var { iconColor } = _a, props = __rest(_a, ["iconColor"]);
    return (_jsxs(StyledCheckIcon, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", color: iconColor }, props, { children: [_jsx("g", { clipPath: "url(#clip0_3554_7512)", children: _jsx("path", { d: "M9.99974 15.172L19.1917 5.979L20.6067 7.393L9.99974 18L3.63574 11.636L5.04974 10.222L9.99974 15.172Z" }) }), _jsx("defs", { children: _jsx("clipPath", { id: "clip0_3554_7512", children: _jsx("rect", { width: "24", height: "24", fill: "white" }) }) })] })));
};
//# sourceMappingURL=CheckIcon.js.map